<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link">&nbsp;Warehouse</p>
                        <p class="text-muted mb-0 hover-cursor link">&nbsp;/&nbsp;Inventory Product</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;{{ stockCode }}</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="d-flex flex-wrap justify-content-between">
                                    <div class="w-100 mt-3 mb-3">
                                        <h5 class="text-center">Edit Inventory Product</h5>
                                    </div>
                                    <div class="card w-100">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label-one"> Type </span>
                                                        <multiselect
                                                            v-model="type"
                                                            :options="$getProductType('unit','')"
                                                            label="statusName"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select Type"
                                                            track-by="statusName"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                            @input="resetSelectField('type')"
                                                        ></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Brand </span>
                                                        <multiselect v-model="brand" :options="brandOption" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Brand" @input="resetSelectField('brand')"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Model </span>
                                                        <multiselect v-model="model" :options="modelOption" label="" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Model" @input="resetSelectField('model')"></multiselect>
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Variant </span>
                                                        <multiselect v-model="catalogSpec" :options="catalogOption" label="specifications" :allow-empty="false" :select-label="''" deselect-label="" placeholder="Variant" track-by="specifications"></multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Status </span>
                                                        <input type="text" name="status" class="form-control text-field" disabled :value="getStockStatusName(detailProduct[0].status)" v-if="detailProduct.length != 0">
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one"> Lessee </span>
                                                        <input type="text" name="lesseename" v-model="lessee" class="form-control" disabled="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card w-100 mt-3">
                                        <div class="card-body">
                                            <h5>Actual Specifications</h5>
                                            <hr>
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label-one"> Stock Code </span>
                                                        <input type="text" name="stockCode" class="form-control text-field" placeholder="Stock Code" v-model="stockCode" disabled>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center" v-if="type.status != 1 && type.status != 2">
                                                        <span class="field-label-one"> SKU </span>
                                                        <multiselect
                                                            v-model="anySku[0]"
                                                            :options="anySkuOption"
                                                            label="skuName"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select SKU"
                                                            track-by="skuName"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                            v-if="detailProduct.length != 0"
                                                        ></multiselect>
                                                    </div> 
                                                </div>
                                            </div>
                                            <div class="row d-flex align-items-center" v-if="type.status == '1' || type.status == '2'">
                                                <div class="col-1" style="max-width: 123px">
                                                    <div class="w-100 d-flex mt-2" >
                                                        <span class="field-label-one"> Processor </span>
                                                    </div>  
                                                </div>
                                                <div class="col-11" style="max-width: 87.3%">
                                                    <div class="w-100 mt-2">
                                                        <multiselect
                                                            v-model="dataActual['processor']"
                                                            :options="getSkuOption(type.status)"
                                                            label="skuName"
                                                            :allow-empty="false"
                                                            :select-label="''"
                                                            :deselect-label="''"
                                                            placeholder="Select SKU"
                                                            track-by="skuName"
                                                            :selectedLabel="''"
                                                            :optionHeight="30"
                                                        ></multiselect>
                                                    </div>  
                                                </div>
                                            </div>
                                            <div v-if="dataActual['ram'].length != 0">
                                                <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['ram']" :key="`actualRam-${index}`">
                                                    <div class="col-1" style="max-width: 123px">
                                                        <div class="w-100 d-flex mt-2">
                                                            <span class="field-label-one"> RAM ke-{{index+1}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-11" style="max-width: 87.3%">
                                                        <div class="w-100 mt-2">
                                                            <multiselect
                                                                v-model="dataActual['ram'][index]"
                                                                :options="getSkuOption(20)"
                                                                label="skuName"
                                                                :allow-empty="false"
                                                                :select-label="''"
                                                                :deselect-label="''"
                                                                placeholder="Select SKU"
                                                                track-by="skuName"
                                                                :selectedLabel="''"
                                                                :optionHeight="30"
                                                            ></multiselect>
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="dataActual['storage'].length != 0">
                                                <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['storage']" :key="`actualStorage-${index}`">
                                                    <div class="col-1" style="max-width: 123px">
                                                        <div class="w-100 d-flex mt-2">
                                                            <span class="field-label-one"> Storage ke-{{index+1}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-11" style="max-width: 87.3%">
                                                        <div class="mt-2">
                                                            <multiselect
                                                                v-model="dataActual['storage'][index]"
                                                                :options="getSkuOption('storage')"
                                                                label="skuName"
                                                                :allow-empty="false"
                                                                :select-label="''"
                                                                :deselect-label="''"
                                                                placeholder="Select SKU"
                                                                track-by="skuName"
                                                                :selectedLabel="''"
                                                                :optionHeight="30"
                                                            ></multiselect>
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="dataActual['vga'].length != 0">
                                                <div class="row d-flex align-items-center" v-for="(data,index) in dataActual['vga']" :key="`actualVga-${index}`">
                                                    <div class="col-1" style="max-width: 123px">
                                                        <div class="w-100 d-flex mt-2">
                                                            <span class="field-label-one"> GPU ke-{{index+1}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-11" style="max-width: 87.3%">
                                                        <div class="mt-2">
                                                            <multiselect
                                                                v-model="dataActual['vga'][index]"
                                                                :options="getSkuOption(23)"
                                                                label="skuName"
                                                                :allow-empty="false"
                                                                :select-label="''"
                                                                :deselect-label="''"
                                                                placeholder="Select SKU"
                                                                track-by="skuName"
                                                                :selectedLabel="''"
                                                                :optionHeight="30"
                                                            ></multiselect>
                                                        </div>  
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center mt-2" v-if="type.status != 5 && type.status != 6">
                                                        <span class="field-label-one"> Serial Number </span>
                                                        <input type="text" name="ram" class="form-control text-field" placeholder="Serial Number" v-model="serialNumber">
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2" v-else>
                                                        <span class="field-label-one"> IMEI </span>
                                                        <input type="text" name="ram" class="form-control text-field" placeholder="IMEI" v-model="serialNumber">
                                                    </div>
                                                    <div class="w-100 d-flex align-items-center mt-2">
                                                        <span class="field-label-one" style="margin-top: -47px;"> Notes </span>
                                                        <textarea rows="3" class="form-control" style="resize: none;" placeholder="Notes" v-model="notes"></textarea>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="text-field"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <table class="fixed_header table-bordered mt-3 w-100 table table-bordered table-striped table-responsive-sm">
                                        <tbody class="full-width">
                                            <tr>
                                                <th style="min-width: 150px;">Date</th>
                                                <th style="min-width: 500px;">Action</th>
                                                <th>Executor</th>
                                            </tr>
                                            <tr v-if="[1,2,3].length == 0">
                                                <td colspan="3">Tidak ada Log</td>
                                            </tr>
                                            <tr v-else v-for="(data, index) in [1,2,3]" :key="index">
                                                <td>0</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <button class="btn btn-sm btn-danger mr-auto" v-if="status.status == 4" @click="openModal('Sell')">Sell</button>
                                    <button class="btn btn-sm btn-primary ml-1">Cancel</button>
                                    <button class="btn btn-sm btn-primary ml-1" @click="validationField" v-if="status.status == 4">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- Modal Save-->
            <div class="modal fade" id="modalSave" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save product?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="loadingButtonSave" @click="submitEdit"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonSave">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <div class="modal fade" id="modalSell" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Sell Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to sell product?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="loadingButtonSell" @click="submitSell"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingButtonSell">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalLog" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-xl">
                      <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Product Name Log</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead class="">
                                    <tr>
                                        <th>Date</th>
                                        <th>Action</th>
                                        <th>Executor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingLog === false && totalData == '0'">
                                        <td colspan="3" class="text-center">Data Not Available</td>
                                    </tr>
                                    <tr v-else-if="loadingLog === true">
                                        <td colspan="3" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                    </tr>
                                    <tr v-for="(data,index) in dataLog" :key="index" v-else>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import CONSTANT from '../constPlugin';
import {Money} from 'v-money'
import SideBar from '../SideBar'
export default {
    name: 'ProductAddPage',
    components: {
        SideBar,
        Multiselect,
        Money
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
            admin: "",
            permission: [],
            viewDashboard: false,
            viewInventoryProduct: false,
            loadingButtonSave: false,
            loadingButtonSell: false,
            loadingLog:false,
            type:[],
            brand:'',
            brandOption:[],
            model:'',
            modelOption:[],
            catalogSpec:[],
            catalogOption:[],
            status:[],
            statusOption:[],
            lessee:'',
            lessor:[],
            lessorOption:[],
            lessorPoint:[],
            lessorPointOption:[],
            purchaseDate:'',
            purchasePrice:'',
            stockCode:'',
            serialNumber:'',
            notes:'',
            detailProduct:[],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            sourceOption:['Procurement', 'Stock Opname'],
            source:'',
            dataActual:[],
            totalData:0,
            dataLog:[],
            allSKU:[],
            skuProcessor:[],
            skuStorage:[],
            skuRam:[],
            skuVga:[],
            skuActual:[],
            anySku:[],
            anySkuOption:[],
            uwId:''
        }
    },
    methods: {
        connectLogProduct: function () {
            this.$http
                .get(process.env.LOG_URL + "/inv_product/" + this.uwId, {
                    headers: { "Asani-Token": localStorage.getItem("jwt") },
                })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.dataLog = response.data.content;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        submitSell(){
            self = this
            this.loadingButtonSell = true
            this.$http.post(process.env.SELL_PRODUCT_INVENTORY,{
                stockCode : this.stockCode !== null ? this.stockCode.replace(this.spaceRegex, ' ') : this.stockCode,
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else if (response.data.status == 200) {
                    $("#modalSell").modal('hide')
                    swal("Success", response.data.message, "success", {
                        button: "Close",
                    }).then((value) => {
                        this.toDetailPage(this.$route.params.id)
                    })
                    this.loadingButtonSell = false
                }
            })
            .catch(error => {
                self.loadingButtonSell = false
                alert('Error With API please try again !')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        getSkuChoose(type){
            var sku = []
            if (type == 'storage') {
                for (var i = 0; i < this.skuActual.length; i++) {
                    if (this.skuActual[i].typeId == 21 || this.skuActual[i].typeId == 22 || this.skuActual[i].typeId == 24) {
                        sku.push({
                            componentId : this.skuActual[i].componentId,
                            skuName : this.skuActual[i].skuName,
                            componentName : this.skuActual[i].componentName,
                            sku : this.skuActual[i].sku,
                            typeId : this.skuActual[i].typeId,
                        })
                    }
                }
            }else{
                for (var i = 0; i < this.skuActual.length; i++) {
                    if (this.skuActual[i].typeId == type) {
                        sku.push({
                            componentId : this.skuActual[i].componentId,
                            skuName : this.skuActual[i].skuName,
                            componentName : this.skuActual[i].componentName,
                            sku : this.skuActual[i].sku,
                            typeId : this.skuActual[i].typeId,
                        })
                    }
                }
            }
            return sku
        },
        getComponentSKU(dataType,dataFor){
            this.$http.post(process.env.GET_COMPONENT_SKU,{
                dataType : dataType,
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                } else if (response.data.status == 200) {
                    if (dataFor == 'any') {
                        this.anySkuOption = response.data.content
                    } else{
                        this.allSKU = response.data.content
                    }
                }
            })
            .catch(error => {
                // self.loadingDataProcurement = false
                alert('Error With API please try again !')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        getSkuOption(type){
            let sku = []
            if (type == '1') {
                type = 1
            }else if (type == '2') {
                type = 18
            }
            if (type == 'storage') {
                for (var i = 0; i < this.allSKU.length; i++) {
                    if (this.allSKU[i].typeId == 21 || this.allSKU[i].typeId == 22 || this.allSKU[i].typeId == 24) {
                        sku.push({
                            componentId : this.allSKU[i].componentId,
                            skuName : this.allSKU[i].skuName,
                            componentName : this.allSKU[i].componentName,
                            sku : this.allSKU[i].sku,
                            typeId : this.allSKU[i].typeId,
                        })
                    }
                }
            }else{
                for (var i = 0; i < this.allSKU.length; i++) {
                    if (this.allSKU[i].typeId == type) {
                        sku.push({
                            componentId : this.allSKU[i].componentId,
                            skuName : this.allSKU[i].skuName,
                            componentName : this.allSKU[i].componentName,
                            sku : this.allSKU[i].sku,
                            typeId : this.allSKU[i].typeId,
                        })
                    }
                }
            }
            return sku
        },
        getProductBrand(type) {
            this.$http.post(process.env.GET_ORDER_PRODUCT_BRAND, {
                    productType: type
                }, {
                    headers: {
                        'Asani-Token': localStorage.getItem('jwt')
                    }
                })
                .then(response => {
                    if (response.data.status !== 200) {
                        swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                    } else {
                        this.brandOption = []
                        for (var i = 0; i < Object.values(response.data.content.productBrand).length; i++) {
                            this.brandOption.push(Object.values(response.data.content.productBrand)[i])
                        }
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                        this.handleLogout()
                        }
                    })
                })
        },
        toDetailPage(id){
          this.$router.push({path:'/inventory/product/detail/'+id, query: {
                  stockCode:'',
                  serialNumber:'',
                  status:'All',
                  statusName:'All',
                  warehouseId:'All',
                  warehouseName:'All',
                  page:1,
                  itemPerPage:10
              }
          })
        },
        resetSelectField(fieldSelect){
            if (fieldSelect == 'type') {
                this.brand = ''
                this.model = ''
                this.catalogSpec = []
                this.getProductBrand(this.type.status)
                if (this.type.status == '1' || this.type.status == '2') {
                    
                }else{
                    this.getComponentSKU([this.type.status],'any')
                    this.dataActual = {}
                }
            }else if (fieldSelect == 'brand') {
                this.model = ''
                this.catalogSpec = []
                this.getProductModel(this.type.status, this.brand)
            }else if (fieldSelect == 'model') {
                this.catalogSpec = []
                this.getCatalogSpec(this.type.status, this.brand,this.model)
            }else if (fieldSelect == 'lessor') {
                this.lessorPoint = []
                this.getLessorPoint(this.lessor.lessorId)
            }
        },
        validationArray(field){
            let result = true
            if (field == 'ram') {
                for (var i = 0; i < this.dataActual['ram'].length; i++) {
                    if(this.dataActual['ram'][i] == ''){
                        result = false
                    }
                }
            }else if (field == 'storage' && this.detailProduct[0].completeness == 1) {
                for (var i = 0; i < this.dataActual['storage'].length; i++) {
                    if(this.dataActual['storage'][i] == ''){
                        result = false
                    }
                }
            }else if (field == 'gpu') {
                for (var i = 0; i < this.dataActual['vga'].length; i++) {
                    if(this.dataActual['vga'][i] == ''){
                        result = false
                    }
                }
            }
            return result
        },
        validateLaptopPc(){
            let result = true
            if (this.type.status == 1 || this.type.status == 2) {
                if (this.dataActual['processor'] == '') {
                    swal("Sorry", "Processor must be fill", "error", {
                        button: "Ok",
                    })
                    result = false
                }else if (this.validationArray('ram') == false) {
                    swal("Sorry", "RAM must be fill", "error", {
                        button: "Ok",
                    })
                    result = false
                }else if (this.validationArray('storage') == false) {
                    swal("Sorry", "storage must be fill", "error", {
                        button: "Ok",
                    })
                    result = false
                }else if (this.validationArray('gpu') == false) {
                    swal("Sorry", "GPU must be fill", "error", {
                        button: "Ok",
                    })
                    result = false
                }
            }
            return result
        },
        validationField() {
            if (this.brand == '') {
                swal("Sorry", "Product brand must be choose", "error", {
                    button: "Ok",
                })
            }else if (this.model == '') {
                swal("Sorry", "Product model must be choose", "error", {
                    button: "Ok",
                })
            }else if (this.catalogSpec.length == 0) {
                swal("Sorry", "Variant must be choose", "error", {
                    button: "Ok",
                })
            }else if (this.validateLaptopPc() == false) {

            }else if ((this.type.status != '1' && this.type.status != '2') && this.anySku.length == 0) {
                swal("Sorry", "SKU must be choose", "error", {
                    button: "Ok",
                })
            }else if (this.serialNumber == '') {
                swal("Sorry", "Serial number must be fill", "error", {
                    button: "Ok",
                })
            } else {
                this.openModal('Save')
            }  
        },
        openModal(x) {
            $("#modal" + x).modal('show')
        },
        toPage(e) {
            this.$router.push(e)
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
            localStorage.removeItem('jwt')
            localStorage.removeItem('admin_name')
            localStorage.removeItem('roles')
            localStorage.removeItem('user_email')
            localStorage.removeItem('admin_id')
            localStorage.removeItem('changeCatalogPermission')
            this.$router.push('/')
        },
        cekLogin() {
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/')
            }
        },
        cekPermission() {
            this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
            for (var i = 0; i < this.permission.length; i++) {
            }
            if (this.editProduct == false) {
                this.$router.push('/')
            }
        },
        sidebar() {
            $("#wrapper").toggleClass("toggled");
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        getStockStatusName(status){
            for (var i = 0; i < CONSTANT.STOCK_STATUS.length; i++) {
                if(status ==CONSTANT.STOCK_STATUS[i].status) return CONSTANT.STOCK_STATUS[i].statusName
            }
            return []
        },
        getData() {
            this.stockCode = this.$route.params.stockCode
            for (var i = 0; i < CONSTANT.STOCK_STATUS.length; i++) {
                this.statusOption.push(CONSTANT.STOCK_STATUS[i])
            }
            this.loadingTable = true
            this.$http.post(process.env.INVENTORY_PRODUCT_GET_PRODUCT_DETAIL,{
                stockCode: this.$route.params.stockCode,
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                        swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                    }else{
                        this.detailProduct = response.data.content.detailProduct
                        this.type = this.$getConstantsObjectS('PRODUCT_TYPE',this.detailProduct[0].typeId);
                        this.brand = this.$getSpecParsing(this.detailProduct[0].allCatalogSpec, 'brand', 'catalog')
                        this.model = this.$getSpecParsing(this.detailProduct[0].allCatalogSpec, 'model', 'catalog')
                        this.catalogSpec = {
                            productId : this.detailProduct[0].productId,
                            specifications : this.detailProduct[0].catalogSpec
                        }
                        this.status = {
                            status : this.detailProduct[0].status,
                            statusName : this.getStockStatusName(this.detailProduct[0].status)
                        }
                        if (this.detailProduct[0].status == 6) {
                            this.lessee = this.detailProduct[0].lesseeName
                        }
                        this.lessor = {
                            lessorId : this.detailProduct[0].lessorId,
                            lessorName : this.detailProduct[0].lessorName
                        }
                        this.lessorPoint = {
                            lessorPointId : this.detailProduct[0].lessorPointId,
                            lessorPointName : this.detailProduct[0].lessorPointName
                        }
                        this.purchaseDate = this.detailProduct[0].purchaseDate
                        this.purchasePrice = this.detailProduct[0].purchasePrice
                        this.serialNumber = this.detailProduct[0].serialNumber
                        this.uwId = this.detailProduct[0].uwId
                        this.brandOption = Object.values(response.data.content.allBrand)
                        this.lessorOption = response.data.content.allLessor
                        this.getLessorPoint(this.detailProduct[0].lessorId)
                        this.getProductModel(this.detailProduct[0].typeId, this.$getSpecParsing(this.detailProduct[0].allCatalogSpec, 'brand', 'catalog'))
                        this.getCatalogSpec(this.detailProduct[0].typeId, this.$getSpecParsing(this.detailProduct[0].allCatalogSpec, 'brand', 'catalog'),this.$getSpecParsing(this.detailProduct[0].allCatalogSpec, 'model', 'catalog'))
                        this.dataActual = this.detailProduct[0].skuChoose
                        if (this.detailProduct[0].typeId == 1 || this.detailProduct[0].typeId == 2) {
                            if (this.detailProduct[0].typeId == 1) {
                                var dataType =[1,20,21,22,23]
                                // this.dataActual['processor'] = this.getSkuChoose(1)
                                // this.dataActual['ram'] = this.getSkuChoose(20)
                                // if (this.detailProduct[0].completeness == 1) {
                                //     this.dataActual['storage'] = this.getSkuChoose('storage')
                                // }
                                // this.dataActual['vga'] = this.getSkuChoose(23)
                            }else{
                                var dataType =[18,20,21,22,23]
                                // this.dataActual['processor'] = this.getSkuChoose(18)
                                // this.dataActual['ram'] = this.getSkuChoose(20)
                                // if (this.detailProduct[0].completeness == 1) {
                                //     this.dataActual['storage'] = this.getSkuChoose('storage')
                                // }
                                // this.dataActual['vga'] = this.getSkuChoose(23)                    
                            }
                            this.getComponentSKU(dataType,'default')
                        }else{
                            this.anySku = this.detailProduct[0].skuChoose
                            this.getComponentSKU([this.type.status],'any')
                        }
                        // this.connectLogProduct()
                        this.loadingTable = false
                    }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        getLessorPoint(lessorId){
            this.$http.post(process.env.GET_LESSOR_POINT,{
                lessorId: lessorId,
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                } else{
                    this.lessorPointOption = response.data.content
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        getProductModel(type, brand){
            this.$http.post(process.env.GET_PRODUCT_MODEL,{
                type: type,
                brand: brand
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else{
                    this.modelOption = response.data.content
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        getCatalogSpec(type, brand, model){
            this.$http.post(process.env.GET_CATALOG_SPEC,{
                type: type,
                brand: brand,
                model: model
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else{
                    this.catalogOption = response.data.content
                }
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
        submitEdit(){
            var self = this
            this.loadingButtonSave = true
            let data = []
            if (this.type.status == 1 || this.type.status == 2) {
                data = {
                    productId : this.catalogSpec.productId,
                    actualSpec : this.dataActual,
                    serialNumber : this.serialNumber,
                    notes : this.notes,
                    typeId : this.type.status
                }
            }else{
                data = {
                    productId : this.catalogSpec.productId,
                    componentId : this.anySku[0].componentId,
                    serialNumber : this.serialNumber,
                    notes : this.notes,
                    typeId : this.type.status
                }
            }
            
            this.$http.post(process.env.INVENTORY_PRODUCT_DETAIL_EDIT,{
                stockCode: this.$route.params.stockCode,
                data: data
              },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
              })
              .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message, "error", {
                            button: "Ok",
                        })

                }else if (response.data.status == 200) {
                    $("#modalSave").modal('hide')
                    swal("Success", response.data.message, "success", {
                        button: "Close",
                    }).then((value) => {
                        this.toDetailPage(this.$route.params.id)
                    })
                    this.loadingButtonSave = false
                } else if (response.data.status == 201) {
                    swal("Sorry", response.data.message, "error", {
                        button: "Ok",
                    });
                    this.loadingButtonSave = false
                    $("#modalSave").modal('hide')
                }
              })
              .catch(error => {
                self.loadingButtonSave = false
                alert('Error With API')
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })
        },
    },
    created() {
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .field-label-one-actual{
        width: 200px
    }
    .gpu-field{
        width: 215px;
    }
    .field-label.gpu{
        width: 163px;
    }
    .gpu-size{
        width: 230px;
    }
    .ram-type{
        width: 156px;
    }
    .text-field{
        height: 42.2px;
    }
    .price{
        height: 42.2px;
    }
    .field-label{
        width: 188px;
    }
    .field-label.ram{
        width: 276px;
    }
    .field-label.storage{
        width: 276px;
    }
    .storage-type{
        width: 318px;
    }
    .field-label-one{
        width: 164px;
    }
    .input-group-addon {
        padding: 7px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #555;
        text-align: center;
        background-color: #eee;
        border: 1px solid #ccc;
        border-radius: 4px 0px 0px 4px;
        border-right: none;
        margin: 0px 0px 0px 10px;
        height: 42.2px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Warehouse/InventoryProductDetailEditPage.vue